module.exports = __webpack_public_path__ + "static/media/file_type_image_error_icon.c6c08669.svg";